import * as React from 'react';

import { log } from 'helper/debug';
import i18n from 'helper/i18n';

import Link from 'components/atoms/Link';
import ButtonBar from 'components/molecules/ButtonBar';
import CardLike from 'components/molecules/Card/elements/Like';
import ContentVideo from 'components/molecules/ContentVideo';
import LinkList from 'components/molecules/LinkList';
import Rich from 'components/molecules/Rich';
import ContentImageSlider from 'components/molecules/Slider/ContentImageSlider';
import { ContainerCardDetailRecommendationPropsType } from 'containers/molecules/Card/Detail/Recommendation';

export type CardDetailRecommendationProps = ContainerCardDetailRecommendationPropsType;

export class CardDetailRecommendation extends React.Component<CardDetailRecommendationProps> {
	public static displayName = 'CardDetailRecommendation';

	public handleButtonClicks = (buttonType: string) => {
		if (this.props.isSequenceLoading) {
			return;
		}

		switch (buttonType) {
			case 'completed':
				this.props.onClickHeart({
					type: this.props.type,
					buttonType,
					onAnimationDone: () => {
						this.props.doHeart(`${this.props.id}`);
						this.props.doComplete(`${this.props.id}`);
					},
				});
				break;
			case 'close':
				this.props.onClickClose({
					type: this.props.type,
					buttonType,
					onAnimationDone: () => {
						this.props.doClose(`${this.props.id}`);
					},
				});
				break;
			default:
				log(`Button Action "${buttonType}" not available`);
		}
	};

	public renderButtonBar = (): any => {
		const { isDone, isCheckable, isSequenceLoading, isUiUpdatingHeart, isUiClosing } = this.props;
		let cardButtons: any = null;

		if (!isCheckable) {
			return null;
		}

		if (!isDone) {
			cardButtons = {
				buttons: [
					{
						loading: isUiUpdatingHeart,
						disabled: isUiClosing,
						knob: {
							modifier: 'dashed',
							size: 'l',
							icon: 'completed',
						},
					},
				],
			};

			return (
				<div className="m-card__button-bar">
					<ButtonBar
						disabled={isSequenceLoading}
						handleButtonClicks={this.handleButtonClicks}
						buttons={cardButtons.buttons}
					/>
				</div>
			);
		}
	};

	public render() {
		const {
			linkList,
			text,
			title,
			contentVideo,
			images,
			favorite,
			infoText,
			handleCardContentClick,
			handleShowDetailsClick,
			handleToggleFavorite,
		} = this.props;

		return (
			<div className="m-card__content" onClick={handleCardContentClick}>
				<div className="m-card__info m-card__info--has-like">
					{title && <h4 className="m-card__info-title">{title}</h4>}
					<CardLike onClick={handleToggleFavorite} liked={favorite} />
					{infoText && (
						<div className="m-card__info-line">
							<p className="m-card__info-text">{infoText}</p>
						</div>
					)}
				</div>
				<div className="m-card__link js-m-card__link">
					<Link
						onClick={handleShowDetailsClick}
						title={i18n('react.impulsCoach.components.cardDetail.recommendation.linkText')}
						modifier="button"
						openInNewWindow={false}
						iconRight={null}
					/>
				</div>
				<div className="m-card__detail">
					{text && <Rich contents={text} />}

					<ContentImageSlider id={title} images={images as any} />
					{contentVideo && (
						<ContentVideo
							caption={contentVideo.caption}
							video={{
								code: contentVideo.video.code,
							}}
						/>
					)}
					{linkList && (
						<LinkList
							links={(linkList.links || []).map((link) => {
								return {
									...link,
									href: void 0,
									externalHref: (link || ({} as any)).href,
								};
							})}
							modifier={linkList.modifier}
						/>
					)}
				</div>
				{this.renderButtonBar()}
			</div>
		);
	}
}

export default CardDetailRecommendation;
